import { Box, Typography } from '@mui/material';
import React from 'react';

export interface GrowthReportMeta {
    week: number;
    title: string;
    subtitle?: string;
    context_lines: string[];
}

export interface GrowthReportHeaderProps {
    meta: GrowthReportMeta;
    organizationName: string;
    reportDate: string;
    pairsCount: number;
}

/**
 * Presentational header for org admin growth reports (and future reuse with equivalent meta).
 */
const GrowthReportHeader: React.FC<GrowthReportHeaderProps> = ({
    meta,
    organizationName,
    reportDate,
    pairsCount,
}) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                {meta.title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
                {organizationName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Report date: {reportDate} — Athletes in cohort (n): {pairsCount}
                {meta.subtitle ? ` — ${meta.subtitle}` : ''}
            </Typography>
            {meta.context_lines?.length ? (
                <Box component="ul" sx={{ pl: 2.5, mt: 1.5, mb: 0 }}>
                    {meta.context_lines.map((line, i) => (
                        <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                            {line}
                        </Typography>
                    ))}
                </Box>
            ) : null}
        </Box>
    );
};

export default GrowthReportHeader;
